import { Component } from '@theme/component';

/**
 * Password page login toggle.
 *
 * Flips `data-password-login` on <body> to switch the page between the Klaviyo
 * email sign-up form and the inline Shopify storefront password form, and swaps
 * this trigger's button label (Login <-> Back to email sign-up). The show/hide of
 * the two forms is handled by CSS keyed off the body attribute (sections/password.liquid).
 *
 * On a wrong-password reload, sections/password.liquid sets the body attribute inline,
 * so connectedCallback just needs to reflect that initial state in the label.
 */
class PasswordLogin extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#updateLabel();
  }

  toggle() {
    const active = document.body.toggleAttribute('data-password-login');
    this.#updateLabel();

    if (active) document.getElementById('Password')?.focus();
  }

  #updateLabel() {
    const button = this.querySelector('button');
    if (!button) return;

    button.textContent = document.body.hasAttribute('data-password-login')
      ? this.dataset.labelActive ?? ''
      : this.dataset.labelDefault ?? '';
  }
}

if (!customElements.get('password-login')) {
  customElements.define('password-login', PasswordLogin);
}
